import React, { useEffect, useState } from "react";
import TabelaPedidosFormando from "./TabelaPedidosFormando";
import axios from "axios";
import { URL_PAGAMENTO } from "../../config/urls";
import { Modal, Spin, Typography, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export default function PedidosPendentes(props) {
  const [progress, setProgress] = useState(false);
  const { Title, Text } = Typography;
  const { confirm } = Modal;

  useEffect(() => { }, [props]);

  function formatarMoedaBr(value) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  }

  const confirmarProducao = (pedidoID) => {
    confirm({
      title: `Você confirma a produção do pedido #${pedidoID}?`,
      icon: <ExclamationCircleOutlined />,
      content: "Se o formando ainda quiser continuar com a compra, confirme a produção.",
      okText: "Confirmar",
      okType: "primary",
      cancelText: "Cancelar",
      onOk() {
        return new Promise((resolve, reject) => {
          setProgress(true);
          axios
            .post(
              `${URL_PAGAMENTO}/confirmar-producao`,
              {
                pedidoID: pedidoID,
              },
              {
                headers: {
                  Authorization: "Bearer " + sessionStorage.getItem("tokenPagamento"),
                },
              }
            )
            .then((response) => {
              props.refresh();
              resolve();
            })
            .catch((error) => {
              console.log(error);
              reject();
            })
            .finally(() => setProgress(false));
        });
      },
      onCancel() { },
    });
  };

  return (
    <div style={{ padding: "10px" }}>
      <Space direction="vertical" style={{ width: "100%", marginBottom: "20px" }}>
        <Text>Há pedidos que ainda não foram pagos.</Text>
        <Text strong>Como proceder?</Text>
        <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
          <li><Text>Você pode solicitar o cancelamento do pedido com a Alpha.</Text></li>
          <li><Text>Se o formando ainda quiser continuar com a compra, você pode confirmar a produção do pedido.</Text></li>
        </ul>
      </Space>

      {!progress && props.formandos.length > 0 ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {props.formandos.map((formando, index) => (
            <div key={index}>
              <div style={{ marginBottom: "10px" }}>
                <Text strong style={{ fontSize: "16px" }}>{formando.nome}</Text>
                <Text type="secondary" style={{ fontSize: "12px", marginLeft: "10px" }}>
                  {formando.curso}
                </Text>
              </div>
              <TabelaPedidosFormando
                handleClickPedido={props.abrirPedido}
                formatarMoedaBr={formatarMoedaBr}
                confirmarProducao={confirmarProducao}
                data={formando.pedidos}
              />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
          {progress ? <Spin tip="Processando..." /> : <Text>Não há pedidos pendentes.</Text>}
        </div>
      )}
    </div>
  );
}